import { linkifyHtml } from '../../../../utils/html'
import { WYSIWYG_EDITOR_EVENT_PASTE_PRE_PROCESS } from '../../WysiwygEditor.constants'

// TinyMCE's native `autolink` plugin only links URLs typed-then-followed by a
// space/enter. Pasted content never triggers it, so bare URLs in copy-pasted
// text stay plain. Linkify the paste payload before it lands in the editor.
export function useEditorPasteAutolink({ enablePasteAutolink }) {
  function handlePastePreProcess(e) {
    if (e?.content) {
      e.content = linkifyHtml(e.content)
    }
  }

  function setup(editor) {
    if (enablePasteAutolink) {
      editor.off?.(
        WYSIWYG_EDITOR_EVENT_PASTE_PRE_PROCESS,
        handlePastePreProcess
      )
      editor.on?.(WYSIWYG_EDITOR_EVENT_PASTE_PRE_PROCESS, handlePastePreProcess)
    }
  }

  return {
    setup,
  }
}
